import { render, staticRenderFns } from "./ModifyCounselingQuestions.vue?vue&type=template&id=3567e087&scoped=true&"
import script from "./ModifyCounselingQuestions.vue?vue&type=script&lang=ts&"
export * from "./ModifyCounselingQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./ModifyCounselingQuestions.vue?vue&type=style&index=0&id=3567e087&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3567e087",
  null
  
)

export default component.exports